import RatingStars from "./RatingStars";

export default function SchoolCard({ school, onClick }) {
  // config level
  const levelConfig = {
    primary: "Tiểu học",
    secondary: "THCS",
    highschool: "THPT",
    university: "Đại học",
  };
  const level = levelConfig[school.level] || "Trường học";
  return (
    <div className="school-card" onClick={() => onClick?.(school)}>
      {/* {school.image && (
        <img
          src={school.image}
          alt={school.name}
          className="school-card__image"
        />
      )} */}

      <div className="school-card__content">
        <div className="school-card__header">
          <h3 className="school-card__title">{school.name}</h3>
          <span className="school-card__level">{level}</span>
        </div>

        {school.short_name && (
          <p className="school-card__subtitle">({school.short_name})</p>
        )}

        <p className="school-card__address">{school.address}</p>

        <p className="school-card__description">
          {school.description || "Chưa có mô tả"}
        </p>
        {school.status === "approved" && (
          <div className="school-card__stats">
            <div className="school-card__rating">
              <div className="school-card__rating-stars">
                <RatingStars rating={school.rating || 0} />
              </div>
              <span className="school-card__rating-value">
                ({school.rating ? school.rating.toFixed(1) : "N/A"})
              </span>
              <span className="school-card__rating-count">
                {school.reviewCount || 0} đánh giá
              </span>
            </div>
          </div>
        )}
        {school.status === "approved" && (
          <button className="school-card__view-btn btn btn--primary">
            Xem chi tiết
          </button>
        )}
      </div>
    </div>
  );
}
